import { getStorage } from '@/utils/storage'
import { STORAGE_SELECT_SEAT_INFO ,STORAGE_CURRENT_SUPPLIER_ID, STORAGE_DETAIL_REFRESH_FLAG, STORAGE_DETAIL_SEARCH_QUERY } from '@/utils/train-storage'
const TRAIN_TIME = [
  {
    key: 1,
    showTime: '00:00-06:00',
    queryTime: ['00:00:00','05:59:59']
  },
  {
    key: 2,
    showTime: '06:00-12:00',
    queryTime: ['06:00:00','11:59:59']
  },
  {
    key: 3,
    showTime: '12:00-18:00',
    queryTime: ['12:00:00','17:59:59']
  },
  {
    key: 4,
    showTime: '18:00-24:00',
    queryTime: ['18:00:00','23:59:59']
  }
]
const TRAIN_TYPE = [
  { type: 'G', text: '高铁(G)' },
  { type: 'D', text: '动车(D)' },
  { type: 'C', text: '城际(C)' },
  { type: 'Z,T,K', text: '普通车(Z/T/K)' },
  { type: 'L,Y', text: '其他(L/Y等)' },
]
const TRANSFER_TRAIN_TYPE = [
  { type: 'PP', text: '普快中转' },
  { type: 'GG', text: '高铁中转' },
  { type: 'GP', text: '高铁转普快' },
  { type: 'PG', text: '普快转高铁' },
]
const TRANSFER_STATION_TYPE = [
  { type: 1, text: '只看同站换乘' },
  // { type: 2, text: '异站换乘' }
]
export default {
  TRAIN_TIME,
  TRAIN_TYPE,
  TRANSFER_TRAIN_TYPE,
  TRANSFER_STATION_TYPE,
  trainListInfo: {},
  trainList: [],
  trainDetail: {},
  trainInfo: {},
  ticketData: [],
  packageInfo: {},
  selectSeatInfo: getStorage(STORAGE_SELECT_SEAT_INFO) || [],
  supplierId: getStorage(STORAGE_CURRENT_SUPPLIER_ID) || '',
  trainDetailRefreshFlag: getStorage(STORAGE_DETAIL_REFRESH_FLAG) || false,
  scrambleChooseTrains:
    (getStorage(STORAGE_DETAIL_SEARCH_QUERY) && [
      getStorage(STORAGE_DETAIL_SEARCH_QUERY)
    ]) ||
    [],
  expectTicket: {}, // 下单参数使用，把用户最开始搜的车次传给后端
  recommendTicket: [], // 坐席选择使用，展示算法推荐的多买少买方案
  showRecommendTickets: true,
  recommendCardInfo: {},
  isTransfer: false, // 用于详情页判断是否走中转，myquery()没有响应式依赖，故添加变量
  makeOrderInfo: {}, //新ui一个页面不走storage走store
  selectRightInfoType: '', // 记录坐席页面选择的权益类型信息(填单页切换权益类型不更新此值) 1快捷购票 2退改无忧 3普通预定
  selectRightInfo: [], // 选中权益信息
  selectPackageItem: {}, // 加速包模块选中加速包信息
  selectPackage: {}, // 按钮最后确定的加速包信息
  selectPackageIndex: 0 // 加速包模块选中加速包信息索引
};
